(function () {
	const initSlider = () => {
		const sliders = document.querySelectorAll(".product-card-js");

		sliders.forEach((slider, index) => {
			const productSlider = new Swiper(slider, {
				loop: true,
				// pagination: {
				// 	el: ".product-pagination .custom-progress-pagination",
				// 	type: "custom",
				// 	renderCustom: function (swiper, current, total) {
				// 		let segments = "";
				// 		for (let i = 1; i <= total; i++) {
				// 			if (i === current) {
				// 				segments += '<span class="bar-segment active"></span>';
				// 			} else {
				// 				segments += '<span class="bar-segment"></span>';
				// 			}
				// 		}
				// 		return segments;
				// 	}
				// },
				navigation: {
					nextEl: ".product-button-group .swiper-button-next",
					prevEl: ".product-button-group .swiper-button-prev",
				},
				scrollbar: {
					el: '.swiper-scrollbar',
					draggable: true
				},
				allowTouchMove: true,
				990: {
					allowTouchMove: true,
				},
			});
		});
	};

	initSlider();

	document.addEventListener("shopify:section:load", function () {
		initSlider();
	});
})();
